import React, { useMemo } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import cn from 'classnames';
import useWindowDimensions from 'Shared/hooks/useWindowDimensions';
import DropdownMenu from 'Components/Admin/DropdownMenu';
import TriangleIcon from 'Components/Admin/TriangleIcon/TriangleIcon';
import { MOBILE_WIDTH_BREAKPOINT } from '../constants/constants';

function Navbar({ localMenu, routes }) {
  const history = useHistory();
  const { width } = useWindowDimensions();

  const activeUrl = useMemo(() => {
    return localMenu
      ? routes.find((route) => route.link.includes(history.location.pathname)) ||
          routes.find((route) => route.isDefault)
      : routes.find((route) => history.location.pathname.includes(route.link));
  }, [history.location.pathname, localMenu, routes]);

  const renderList = () => (
    <ul>
      {routes.map((urlItem) => (
        <li key={urlItem.link}>
          <NavLink exact={localMenu} to={urlItem.link} className={cn({ active: activeUrl?.name === urlItem.name })}>
            {urlItem.name}
          </NavLink>
        </li>
      ))}
    </ul>
  );

  return (
    <div className="navbar-admin">
      {localMenu || width > MOBILE_WIDTH_BREAKPOINT ? (
        renderList()
      ) : (
        <div className="navbar-admin__dropdown-menu">
          <DropdownMenu
            binding="bottom"
            triggerButtonRender={(isOpen) => (
              <div className="navbar-admin__selected-url">
                <span>{activeUrl.name}</span>
                <TriangleIcon direction={isOpen ? 'up' : 'down'} />
              </div>
            )}
          >
            {routes.map((urlItem) => (
              <li key={urlItem.link}>
                <NavLink exact={urlItem.exact} to={urlItem.link}>
                  {urlItem.name}
                </NavLink>
              </li>
            ))}
          </DropdownMenu>
        </div>
      )}
    </div>
  );
}

export default Navbar;

Navbar.defaultProps = {
  localMenu: false,
};
